import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ez24ksxptb: FaireBrandEntity = {
  token: "b_ez24ksxptb",
  type: "brand",
  name: "Cedar Crate Market",
  avatarUrl:
    "https://cdn.faire.com/fastly/3b5e6ac0a64ee6f2df05a8cc17773579c042238b0114bdd2966008f377b9846a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/89f00b079fd6c007fc3ab27f45ac2881400ca1e8bf90e3d3dc07c99286cd462b.png",
  logoUrl:
    "https://cdn.faire.com/fastly/3b5e6ac0a64ee6f2df05a8cc17773579c042238b0114bdd2966008f377b9846a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/89f00b079fd6c007fc3ab27f45ac2881400ca1e8bf90e3d3dc07c99286cd462b.png",
  location: "Minnetonka, MN, USA",
  minimumOrderDollars: 140,
  rating: 5,
  reviewCount: 230,
  isTopShop: true,
  isInsider: true,
  description:
    "A little bit about our family business and how it all began . . . . Cedar Crate Market is a family of creative artists and designers located by the shores of Lake Minnetonka in Minnesota.  \n\nOur journey began in 2017 with a simple idea . . . produce American made gifts that were fun and had a touch of humor.  With this in mind, we began researching and testing soy candles.  \n\nOur goal was to create beautiful premium scented candles with a clean, non-toxic burn and we wanted to produce all of our candles in our own studio. \n\nIN 2018, we expanded our offerings to include engraved sentimental picture frames, beautiful wall signs, and much more! We are constantly expanding our brand to follow the latest trends and provide our customers with the best selection of gifts and home décor. \n\nWe work every day to design items that will enhance your life and home. We work with bright colors, trending designs and fun sayings to make you smile every day.    \n\nThanks for supporting our small business - we love what we do and are grateful for people like you who support our products. \n\nThe Cooks, \nKathi, Mike, Joe and Sarah",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:34.136Z",
    importedBy: "entity-db-cli",
  },
};
